class ToggleClass {
    constructor(statement, element, toggleClass) {
        const toggle = statement ? 'add' : 'remove';
        element.classList[toggle](toggleClass);
    }
}

export default ToggleClass;
